import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import ProductList from '../../components/ProductList/ProductList';
import productsData from '../../data/products.json';

const stockContent = {
  subtitle: "软件解决方案",
  title: "股票&证券",
  description: [
    "股票与证券投资瞬息万变，我们致力于为投资者提供直观的数据可视化工具与精准的市场分析，助您实时掌握股市动态，快速识别投资机会并有效规避风险，提升投资决策的效率和准确性。",
    "向下滑动，深入探索更多专业股票与证券分析工具，助您赢在每个投资时点。",
  ],
  image: "/images/solutions/gupiao.png"
};

const stockProducts = {
  title: "我们的产品",
  subtitle: "证券投资解决方案",
  products: productsData.gupiaoproducts
};

const Stock = () => {
  return (
    <div className="stock-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...stockContent} />

      <div style={{ backgroundColor: '#f8f9fa' }}>
        <ProductList {...stockProducts} />
      </div>
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Stock; 